import 'react-multi-carousel/lib/styles.css';
import './LinkBricks.css';

// Import images
import img1 from '../../assets/img/Waven1.jpg';
import img2 from '../../assets/img/Waven2.jpg';
import img3 from '../../assets/img/Waven3.jpg';
import img4 from '../../assets/img/Waven4.jpg';
import img5 from '../../assets/img/Waven5.jpg';
import img6 from '../../assets/img/Waven6.jpg';
import img7 from '../../assets/img/Waven7.png';
import img8 from '../../assets/img/Waven8.jpg';
import img9 from '../../assets/img/Waven9.jpg';
import img10 from '../../assets/img/Waven10.gif';

export const WavenDetail = () => {

  return (
    <div>
      {/* Theme Background Image */}
      <div className="hero-image" style={{ backgroundImage: `url(${img6})` }}>
      </div>

      {/* Project Background Section */}
      <section className="section">
        <h2 className="section-title">Project Background</h2>
        <p className="section-text">
        
        </p>
        <p className="section-text">
        Waven is an innovative intelligent wearable device designed as part of a conceptual project developed during the Future Intelligent Wearable Haptic Fabric Workshop at Tsinghua University's Future Lab. By seamlessly integrating textile technology and advanced vibration modules, Waven enhances sensory experiences, breaking conventional boundaries of tactile perception.
        </p>
        <strong>Year: 2024.5 - 2024.7</strong>
      </section>

      {/* First Module: Conceptual */}
      <section className="section">
        <h2 className="section-title">Conceptual</h2>

        {/* Insert Images */}
        <div className="image-container">
          <img src={img10} alt="Mafalda Exhibition" className="project-image no-hover-effect" />
          <p className="image-description">The three classic forms of Tangible User Interface (TUI) </p>
        </div>

        <div className="image-container-vertical">
          <img src={img3} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img5} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img2} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img9} alt="Exhibition" className="project-image-vertical no-hover-effect" />
        </div>
        <p className="image-description">
          Crafted specifically for urban lifestyles, Waven allows users to briefly escape daily routines through tactile simulations of ocean waves, sandy beaches, and warm sunlight. This unique wearable system provides an immersive, fragmented "vacation moment," effortlessly blending one's everyday experiences with rejuvenating sensory escapes.
        </p>
      </section>

      {/* Second Module: Demo */}
      <section className="section">
        <h2 className="section-title">Demo</h2>

        <div className="image-container-vertical">
          <img src={img7} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img4} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img1} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img8} alt="Exhibition" className="project-image-vertical no-hover-effect" />
        </div>
        <p className="image-description">The Waven demo was realized through extensive material experimentation and precise three-dimensional tailoring, demonstrating the potential of haptic textile technology and its integration into wearable forms.
        </p>
      </section>

      {/* Credits Section */}
      <section className="section">
        <h2 className="section-title">Credits</h2>
        <p className="image-description">
          <strong>Storyboard:</strong> Midjourney<br />
          <strong>Video Production:</strong> Runway<br />
          <strong>Music Composition and Sound Design:</strong> Suno<br />
          <strong>Voiceover Tool:</strong> Uberduck<br />
          <strong>Visual Enhancement:</strong> ChatGPT
        </p>
      </section>
    </div>
  );
};

export default WavenDetail;